import { memo, ReactNode } from "react";
import classNames from "classnames";

import styles from "./style.module.scss";

export type TableActionsProps = {
  className?: string
  children: ReactNode
}

export default memo<TableActionsProps>((
  {
    className,
    children,
  }) => {
  return (
    <div className={classNames(className, styles.root)}>
      {children}
    </div>
  );
});

